// extracted by mini-css-extract-plugin
export var childPages = "ArticleTagList-module--childPages--N6L4i";
export var footer = "ArticleTagList-module--footer--d5RL5";
export var siblingPages = "ArticleTagList-module--siblingPages--LEjfZ";